export default function FormFieldError({ message }: { message: string }) {
    return (
        <span role="alert" className="text-yellow-600 text-sm">
            {message}
        </span>
    )
}
